// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"92df3c16","154":"29bc2904","328":"4de8b159","376":"f3467bf8","574":"40ff5a66","578":"6cc64901","668":"2287df86","703":"3e9b9b0b","724":"72de2383"}[chunkId] + ".chunk.css";
};